module.exports = __webpack_public_path__ + "static/media/life-cycle-slow.b2e49017.mp3";